import { fetchPropertyBusinessUnits } from '../ApSetup/apEnrichUtils';

export { fetchPropertyBusinessUnits as fetchWorkforceBusinessUnits };

export const formatBusinessUnitLabel = (unit) => {
  if (!unit) return '';
  const code = unit.businessUnitCode || unit.propertyCode || unit.PROPERTY_CODE || '';
  const name = unit.businessUnitName || unit.propertyName || unit.PROPERTY_NAME || '';
  if (code && name) return `${code} - ${name}`;
  return name || code || unit.propertyId || unit.PROPERTY_ID || '';
};

export const resolveWorkforceScope = (unit) => {
  const propertyId = unit?.propertyId || unit?.PROPERTY_ID || '';
  const businessUnitId = unit?.businessUnitId || '';
  const businessUnitName = unit?.businessUnitName || unit?.propertyName || unit?.PROPERTY_NAME || '';
  const businessUnitCode = unit?.businessUnitCode || unit?.propertyCode || unit?.PROPERTY_CODE || '';
  const jobCodeLevel2 =
    unit?.jobCodeLevel2 || unit?.job_code_level_2 || unit?.JOB_CODE_LEVEL_2 || '';
  return {
    propertyId,
    businessUnitId,
    businessUnitName,
    businessUnitCode,
    jobCodeLevel2,
    label: formatBusinessUnitLabel(unit),
  };
};

/** @deprecated Use selectedBusinessUnit + resolveWorkforceScope */
export const resolveSelectedBusinessUnit = resolveWorkforceScope;
